// extracted by mini-css-extract-plugin
export default {"changeActionMenu":"select-action-menu_changeActionMenu__Uacb8"};